import React, { useState } from 'react';
import Image from './image';
import Request from 'superagent';
import { Grid, Row, Col, Button } from 'react-bootstrap';

export default function ImageEditModule({ eventModuleRow, updateEventModuleRow, userProfile, eventID }) {
    const [uploadDisabled, setUploadDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [currentImageFile, setCurrentImageFile] = useState(eventModuleRow.name);
    const [file, setFile] = useState(null);

    function buildImageUrl(filename) {
        return userProfile[0].serverIP + '/images/' +
            userProfile[0].customer_id + '/' +
            userProfile[0].site_id + '/' +
            eventID + '/' +
            filename;
    }

    function uploadFile() {
        const parameters = {
            eventID,
            customerID: userProfile[0].customer_id,
            siteID: userProfile[0].site_id,
            eventGroupingSeq: eventModuleRow.event_grouping_seq,
        };
        const formData = new FormData();
        formData.append('image', file);
        const url = userProfile[0].serverIP + '/php/upload.php?argument1=uploadFile&argument2=' + JSON.stringify(parameters);
        Request.post(url)
            .send(formData)
            .then((response) => {
                if (response.body[0].Result !== 'OK') {
                    alert('In imageEditModule: ' + response.body[0].Result);
                } else {
                    setErrorMessage('Image upload successful');
                    setCurrentImageFile(file.name);
                    updateEventModuleRow({
                        name: file.name,
                        event_grouping_seq: eventModuleRow.event_grouping_seq,
                        module_type_id: eventModuleRow.module_type_id,
                    });
                }
            });
        setUploadDisabled(true);
    }

    function fileSelected(e) {
        if (e.target.files[0].size > 1048576) {
            setErrorMessage('Image files must be less than 1MB in size');
        } else {
            setUploadDisabled(false);
            setErrorMessage('');
            setFile(e.target.files[0]);
        }
    }

    const errorMessageStyle = { color: 'red' };

    return (
        <Grid>
            <Row>
                <Col xs={4} style={{ fontSize: '18px', paddingRight: 0, paddingLeft: '10px' }}>
                    New File
                </Col>
                <Col xs={3} style={{ fontSize: '18px', paddingRight: 0, paddingLeft: '10px' }}>
                    <Image src={buildImageUrl(currentImageFile)}
                        width={180}
                        height={180}
                        style={{ position: 'absolute' }}
                        mode='fit' />
                </Col>
            </Row>
            <Row>
                <Col xs={5} style={{ fontSize: '16px', paddingTop: '10px', paddingLeft: '5px' }}>
                    <input type="file" id={'imageFile' + eventModuleRow.event_grouping_seq} name="imageFile"
                        accept=".jpg, .jpeg, .png"
                        onChange={fileSelected} />
                </Col>
            </Row>
            <Row>
                <Col xs={1} style={{ paddingLeft: '5px', paddingTop: '10px' }}>
                    <Button key="upload" name="upload" bsStyle="success"
                        disabled={uploadDisabled}
                        onClick={uploadFile}>
                        Upload File
                    </Button>
                </Col>
                <Col xs={4} style={{ fontSize: '18px', paddingTop: '14px', marginLeft: '20px' }}>
                    <span style={errorMessageStyle}>{errorMessage}</span>
                </Col>
            </Row>
            <Row>
                <Col xs={2} style={{ fontSize: '18px', paddingTop: '20px', paddingLeft: '5px' }}>
                    Current File
                </Col>
            </Row>
            <Row>
                <Col xs={5} style={{ fontSize: '16px', paddingLeft: '5px', paddingTop: 0 }}>
                    {currentImageFile}
                </Col>
            </Row>
        </Grid>
    );
}
